import { axios } from 'lib/axios';

export const verifySMSOTP = (data) => {
  return axios.patch('/user/sms/verifyCode', data);
};
